module.exports = __webpack_public_path__ + "static/img/36.a7325f0.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/img_left_icon/36.png
// module id = Ionj
// module chunks = 1